const defaultConfig = {
  test: {
    VITE_APP_ENV: 'test',
    VITE_BASEURL: '/',
    VITE_BASEURL_API: 'https://overseas-parent-api.chengjiukehu.com',
    VITE_BASEURL_STREAM_API: '/streamapi',
    VITE_DIFY_PAGE_URL: 'https://localhost:3000',
    VITE_DIFY_M_PAGE_URL: 'https://localhost:3000'
  },
  pre: {
    VITE_APP_ENV: 'pre',
    VITE_BASEURL: '/',
    VITE_BASEURL_API: 'https://overseas-parent-api-pre.thinkbuddy.com',
    VITE_BASEURL_STREAM_API: '/streamapi',
    VITE_DIFY_PAGE_URL: 'https://localhost:3000',
    VITE_DIFY_M_PAGE_URL: 'https://localhost:3000'
  },
  pro: {
    VITE_APP_ENV: 'pro',
    VITE_BASEURL: '/',
    VITE_BASEURL_API: 'https://overseas-parent-api.thinkbuddy.com',
    VITE_BASEURL_STREAM_API: '/streamapi',
    VITE_DIFY_PAGE_URL: 'https://localhost:3000',
    VITE_DIFY_M_PAGE_URL: 'https://localhost:3000'
  }
}
const userAgent = (navigator.userAgent || '').split(' ') || [];
const envList = ['test', 'pre', 'pro']
const envTarget = userAgent[userAgent.length - 1]

let currentEnv;
if (envList.includes(envTarget)) {
  currentEnv = defaultConfig[envTarget]
} else {
  //获取配置文件中的VITE_BASEURL_API
  currentEnv = process.env.VITE_BASEURL_API ||  defaultConfig.test
}

export default currentEnv
